// Variáveis disponíveis para mensagem da proposta de lead
import { getTemplate, getTemplateComVariacoes } from '@/lib/mensagemTemplate';

export interface PropostaVariable {
  key: string;
  label: string;
  exemplo: string;
}

export interface PropostaVariableCategory {
  label: string;
  variables: PropostaVariable[];
}

export const LEAD_PROPOSTA_VARIABLES: PropostaVariableCategory[] = [
  {
    label: 'Consultor',
    variables: [
      { key: '{consultor_nome}', label: 'Nome do Consultor', exemplo: 'Douglas Friggi' },
      { key: '{consultor_email}', label: 'Email do Consultor', exemplo: 'douglas@prime.com' },
    ],
  },
  {
    label: 'Empresa',
    variables: [
      { key: '{razao_social}', label: 'Razão Social', exemplo: 'TMI Comercio EIRELI' },
      { key: '{cnpj}', label: 'CNPJ', exemplo: '02.917.637/0001-72' },
      { key: '{uf}', label: 'UF', exemplo: 'RS' },
    ],
  },
  {
    label: 'Contato',
    variables: [
      { key: '{contato_nome}', label: 'Nome do Contato', exemplo: 'João Silva' },
      { key: '{contato_telefone}', label: 'Telefone do Contato', exemplo: '(51) 98765-4321' },
      { key: '{contato_email}', label: 'Email do Contato', exemplo: 'joao@empresa.com' },
      { key: '{contato_cargo}', label: 'Cargo do Contato', exemplo: 'Gerente' },
    ],
  },
  {
    label: 'Plano Atual',
    variables: [
      { key: '{linhas_atual}', label: 'Linhas Atuais', exemplo: '2' },
      { key: '{gb_atual}', label: 'GB Atual', exemplo: '50' },
      { key: '{valor_atual}', label: 'Valor Atual', exemplo: 'R$ 890,00' },
      { key: '{fibra_atual}', label: 'Fibra Atual', exemplo: '500 Mega' },
      { key: '{tv_atual}', label: 'TV Atual', exemplo: 'Claro Box' },
    ],
  },
  {
    label: 'Plano Novo',
    variables: [
      { key: '{linhas_novo}', label: 'Linhas Novo', exemplo: '3' },
      { key: '{gb_novo}', label: 'GB Novo', exemplo: '100' },
      { key: '{valor_novo}', label: 'Valor Novo', exemplo: 'R$ 750,00' },
      { key: '{fibra_novo}', label: 'Fibra Novo', exemplo: '400 Mega' },
      { key: '{tv_novo}', label: 'TV Novo', exemplo: 'Compacto HD' },
    ],
  },
  {
    label: 'Economia',
    variables: [
      { key: '{economia}', label: 'Economia R$', exemplo: 'R$ 140,00' },
      { key: '{economia_percent}', label: 'Economia %', exemplo: '15%' },
    ],
  },
];

// =====================================================
// MENSAGENS PADRÃO UNIFICADAS (para todos os tipos de lead)
// =====================================================

export const DEFAULT_APRESENTACAO_MESSAGE = `Ola {contato_nome},

Sou *{consultor_nome}*, Consultor da *Empresarial Prime*, representante autorizado *Claro Empresas*.

Atuo como consultor especializado para empresas como a *{razao_social}*, oferecendo solucoes corporativas em:

📱 Planos Moveis CNPJ
📡 Internet Fibra Empresarial  
📺 TV por assinatura
☁️ Solucoes em Nuvem e Servicos Digitais (Microsoft 365, seguranca)
📞 Telefonia Fixa
🔗 Link Dedicado
📶 Pontos de Acesso Wi-Fi

*Meu trabalho e garantir que sua empresa tenha as melhores condicoes do mercado, seja em uma nova contratacao ou na renovacao do seu contrato atual.*

Posso apresentar as vantagens exclusivas que temos para o CNPJ da sua empresa?

Fico a disposicao! 🤝`;

export const DEFAULT_PROPOSTA_MESSAGE = `Olá {contato_nome},

Sou *{consultor_nome}*, da *Empresarial Prime - Claro Empresas*.

Analisei a situação da *{razao_social}* e preparei uma proposta personalizada:

📱 *Plano Atual:*
• {linhas_atual} linhas
• {gb_atual}GB
• Fibra: {fibra_atual}
• TV: {tv_atual}
• {valor_atual}/mês

✨ *Proposta:*
• {linhas_novo} linhas
• {gb_novo}GB
• Fibra: {fibra_novo}
• TV: {tv_novo}
• {valor_novo}/mês

💰 *Economia: {economia}/mês ({economia_percent})*

🎁 *Benefícios:*
• WhatsApp e Waze ilimitados
• Redes Sociais inclusas
• McAfee Security
• Nota fiscal para a empresa

Posso explicar os detalhes da proposta?`;

export const DEFAULT_RETORNO_MESSAGE = `Olá {contato_nome}, tudo bem?

Aqui é *{consultor_nome}*, da *Empresarial Prime - Claro Empresas*.

Enviei uma proposta para a *{razao_social}* e gostaria de saber se teve a oportunidade de analisar.

📋 *Resumo:*
• De {valor_atual}/mês para {valor_novo}/mês
• Economia de {economia}/mês

Podemos conversar para esclarecer dúvidas?`;

export const DEFAULT_FECHAMENTO_MESSAGE = `Olá {contato_nome}! 🎉

Que ótimo fechar com você!

Vou preparar a migração das suas linhas para o CNPJ *{razao_social}*:

📱 *Plano Aprovado:*
• {linhas_novo} linhas CNPJ
• {gb_novo}GB
• {valor_novo}/mês

📋 *Próximos passos:*
1. Vou gerar o pedido no sistema
2. Você receberá o contrato para assinatura digital
3. Confirmação da sua identidade via biometria facial pelo link oficial da Claro Empresas
4. Pedido aprovado e iniciamos a ativação das linhas

Qualquer dúvida estou à disposição! 🤝`;

export const DEFAULT_APRESENTACAO_CARTEIRA_MESSAGE = `Prezado(a) {contato_nome},

Me chamo *{consultor_nome}* e, a partir de agora, sou o seu Gerente de Contas responsável pelo atendimento do CNPJ {cnpj} – {razao_social}.

Nossa empresa, *Empresarial Prime*, passa a atuar oficialmente como Parceiro Autorizado Claro Empresas na gestão da sua conta.

Recebemos recentemente a responsabilidade sobre uma carteira estratégica de clientes corporativos da Claro, e por isso faço questão de me apresentar pessoalmente. Nosso papel é garantir acompanhamento próximo, revisão contratual preventiva e otimização de custos sempre que houver oportunidade.

------------------------------

PLANO ATUAL:

{linhas_atual} LINHAS
{gb_atual}GB
{valor_atual} MENSAL

------------------------------

PLANO NOVO:

{linhas_novo} LINHAS
{gb_novo}GB
{valor_novo} MENSAL

• Manutenção das linhas sem troca de chips
• WhatsApp e Waze ilimitados
• Gestor Online
• McAfee
• Skeelo

------------------------------

Nosso objetivo é simples: garantir que sua empresa esteja com a melhor configuração técnica e financeira possível, com acompanhamento ativo e suporte direto.

Peço que responda esta mensagem ou me chame aqui pelo WhatsApp para alinharmos rapidamente.

Fico à disposição para cuidarmos da sua conta com a atenção que ela merece.

*{consultor_nome}*
Gerente de Contas — Empresarial Prime`;

// =====================================================
// MENSAGENS PADRÃO CPF (Prime Conecta · Claro) — mesma estrutura das CNPJ,
// com a linguagem de pessoa física: sem CNPJ, sem "empresa", sem nota fiscal.
// =====================================================

export const DEFAULT_APRESENTACAO_MESSAGE_PF = `Olá, {primeiro_nome}, tudo bem? Aqui é {consultor_nome}, da Claro.
Analisei os planos da sua linha e vi que dá para melhorar o que você tem hoje em celular, internet e TV.
Posso te mandar um comparativo?`;

export const DEFAULT_PROPOSTA_MESSAGE_PF = `Olá {contato_nome},

Sou *{consultor_nome}*, da *Prime Conecta - Claro*.

Preparei uma proposta personalizada para você:

📱 *Plano Atual:*
• {linhas_atual} linhas
• {gb_atual}GB
• Fibra: {fibra_atual}
• TV: {tv_atual}
• {valor_atual}/mês

✨ *Proposta:*
• {linhas_novo} linhas
• {gb_novo}GB
• Fibra: {fibra_novo}
• TV: {tv_novo}
• {valor_novo}/mês

💰 *Economia: {economia}/mês ({economia_percent})*

Posso explicar os detalhes da proposta?`;

export const DEFAULT_RETORNO_MESSAGE_PF = `Olá {contato_nome}, tudo bem?

Aqui é *{consultor_nome}*, da *Prime Conecta - Claro*.

Te enviei uma proposta e gostaria de saber se teve a oportunidade de analisar.

📋 *Resumo:*
• De {valor_atual}/mês para {valor_novo}/mês
• Economia de {economia}/mês

Podemos conversar para esclarecer dúvidas?`;

export const DEFAULT_FECHAMENTO_MESSAGE_PF = `Olá {contato_nome}! 🎉

Que ótimo fechar com você!

Vou preparar o seu pedido:

📱 *Plano Aprovado:*
• {linhas_novo} linhas
• {gb_novo}GB
• {valor_novo}/mês

📋 *Próximos passos:*
1. Vou gerar o pedido no sistema
2. Você receberá o aceite para confirmar
3. Confirmação da sua identidade pelo link oficial da Claro
4. Pedido aprovado e iniciamos a ativação

Qualquer dúvida estou à disposição! 🤝`;

export const DEFAULT_APRESENTACAO_CARTEIRA_MESSAGE_PF = `Olá, {primeiro_nome}, tudo bem? Aqui é {consultor_nome}, da Claro.
A partir de agora sou eu quem cuida da sua conta Claro.
Já analisei sua conta e separei um resumo das suas linhas, planos e valores.
Quer que eu te envie?`;

// Aliases legados (compatibilidade)
export const DEFAULT_PROPOSTA_MESSAGE_TT = DEFAULT_PROPOSTA_MESSAGE;
export const DEFAULT_RETORNO_MESSAGE_TT = DEFAULT_RETORNO_MESSAGE;
export const DEFAULT_FECHAMENTO_MESSAGE_TT = DEFAULT_FECHAMENTO_MESSAGE;
export const DEFAULT_PROPOSTA_MESSAGE_RENOVACAO = DEFAULT_PROPOSTA_MESSAGE;
export const DEFAULT_RETORNO_MESSAGE_RENOVACAO = DEFAULT_RETORNO_MESSAGE;
export const DEFAULT_FECHAMENTO_MESSAGE_RENOVACAO = DEFAULT_FECHAMENTO_MESSAGE;

// =====================================================
// HELPER: Selecionar mensagens (unificado para todos os tipos)
// =====================================================
export function getDefaultMessages(_tipoLead?: string, tipoPessoa?: string | null) {
  if (tipoPessoa === 'PF') {
    return {
      apresentacao: DEFAULT_APRESENTACAO_MESSAGE_PF,
      proposta: DEFAULT_PROPOSTA_MESSAGE_PF,
      retorno: DEFAULT_RETORNO_MESSAGE_PF,
      fechamento: DEFAULT_FECHAMENTO_MESSAGE_PF,
      apresentacao_carteira: DEFAULT_APRESENTACAO_CARTEIRA_MESSAGE_PF,
    };
  }
  return {
    apresentacao: DEFAULT_APRESENTACAO_MESSAGE,
    proposta: DEFAULT_PROPOSTA_MESSAGE,
    retorno: DEFAULT_RETORNO_MESSAGE,
    fechamento: DEFAULT_FECHAMENTO_MESSAGE,
    apresentacao_carteira: DEFAULT_APRESENTACAO_CARTEIRA_MESSAGE,
  };
}

export function ehMensagemPadrao(texto: string | null | undefined, chave: 'apresentacao' | 'proposta' | 'retorno' | 'fechamento' | 'apresentacao_carteira'): boolean {
  return texto === getDefaultMessages('', 'PJ')[chave] || texto === getDefaultMessages('', 'PF')[chave];
}

/**
 * Versão async que busca templates do banco (com fallback para constantes hardcoded).
 * Usa chaves unificadas que servem para TT, Renovação e Portabilidade.
 */
export async function getDefaultMessagesFromDB(_tipoLead?: string) {
  const [apresentacao, proposta, retorno, fechamento, apresentacao_carteira] = await Promise.all([
    getTemplate('lead.apresentacao', DEFAULT_APRESENTACAO_MESSAGE),
    getTemplate('lead.proposta', DEFAULT_PROPOSTA_MESSAGE),
    getTemplate('lead.retorno', DEFAULT_RETORNO_MESSAGE),
    getTemplate('lead.fechamento', DEFAULT_FECHAMENTO_MESSAGE),
    getTemplate('lead.apresentacao_carteira', DEFAULT_APRESENTACAO_CARTEIRA_MESSAGE),
  ]);

  return { apresentacao, proposta, retorno, fechamento, apresentacao_carteira };
}

/**
 * Versão async que devolve TODAS as variações A/B/C de cada template (não só a principal).
 * Use junto com `selecionarVariacaoPorLead` para escolher de forma determinística qual
 * variação enviar para um lead específico (mesmo lead → mesma variação sempre).
 */
// Cada tipo de lead CPF tem a sua apresentação (Douglas 27/09/2026): a mesma que
// o disparador da Venda IA CPF usa. Sem modelo do tipo, vale a apresentação CPF geral.
const APRESENTACAO_DO_TIPO_CPF: Record<string, string> = {
  PORTABILIDADE_CPF: 'lead_pf.port_cpf.apresentacao',
  RENOVACAO_CPF: 'lead_pf.renov_cpf.apresentacao',
  RETENCAO_CPF: 'lead_pf.retencao_cpf.apresentacao',
};

export async function getDefaultMessagesFromDBComVariacoes(_tipoLead?: string, tipoPessoa?: string | null, opcoes?: { creditoAprovado?: boolean }) {
  const pf = tipoPessoa === 'PF';
  const prefixo = pf ? 'lead_pf' : 'lead';
  const padrao = getDefaultMessages(_tipoLead, tipoPessoa);
  const chaveDoTipo = pf && _tipoLead ? APRESENTACAO_DO_TIPO_CPF[_tipoLead] : undefined;
  const geral = await getTemplateComVariacoes(`${prefixo}.apresentacao`, [padrao.apresentacao]);
  const doTipo = chaveDoTipo
    ? await getTemplateComVariacoes(
        _tipoLead === 'RETENCAO_CPF' && opcoes?.creditoAprovado ? 'lead_pf.retencao_cpf_aprovado.apresentacao' : chaveDoTipo,
        geral.mensagens)
    : geral;
  const [apr, apc, prop, ret, fec] = await Promise.all([
    Promise.resolve(doTipo),
    getTemplateComVariacoes(`${prefixo}.apresentacao_carteira`, [padrao.apresentacao_carteira]),
    getTemplateComVariacoes(`${prefixo}.proposta`, [padrao.proposta]),
    getTemplateComVariacoes(`${prefixo}.retorno`, [padrao.retorno]),
    getTemplateComVariacoes(`${prefixo}.fechamento`, [padrao.fechamento]),
  ]);
  return {
    apresentacao: apr.mensagens,
    apresentacao_carteira: apc.mensagens,
    proposta: prop.mensagens,
    retorno: ret.mensagens,
    fechamento: fec.mensagens,
  };
}

/**
 * Hash estável (FNV-1a 32-bit simplificado) para seedar a escolha de variação.
 * O mesmo lead.id sempre retorna o mesmo índice — leads diferentes distribuem A/B/C.
 */
function hashSeed(seed: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h >>> 0;
}

/** Escolhe uma variação A/B/C de forma determinística com base no lead.id. */
export function selecionarVariacaoPorLead(variacoes: string[], leadId: string | undefined | null): string {
  if (!variacoes || variacoes.length === 0) return '';
  if (variacoes.length === 1 || !leadId) return variacoes[0];
  const idx = hashSeed(leadId) % variacoes.length;
  return variacoes[idx];
}
